import * as React from 'react';
import { SVGProps } from 'react';

const IconSpeedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 6.995A4.997 4.997 0 0 1 6 2a4.997 4.997 0 0 1 3.852 8.18l.77.64A5.973 5.973 0 0 0 12 6.994C12 3.654 9.284 1 6 1S0 3.654 0 6.995c0 1.456.52 2.79 1.379 3.824l.77-.638A4.973 4.973 0 0 1 1 6.995Z" />
    <path d="M6.897 7.78c-.311.445-.937.547-1.398.225-.46-.321-.582-.943-.271-1.39.31-.446 3.18-2.783 3.18-2.783s-1.2 3.501-1.511 3.947Z" />
  </svg>
);
export default IconSpeedSizeXs;
